const updateDataWithId = (array, id, identifier, updatingData) => {
  let iterator,
    newProducts = new Array();
  for (let i = 0; i < array.length; i++) {
    iterator = array[i];
    if (iterator[identifier] === id) {
      iterator = new Object({
        ...iterator,
        ...updatingData,
      });
    }
    newProducts.push(iterator);
  }
  return newProducts;
};

const findWithId = (array, id, identifier) => {
  let iterator,
    index = -1;
  let response = {};
  for (let i = 0; i < array.length; i++) {
    iterator = array[i];
    if (iterator[identifier] == id) {
      index = i;
      response = iterator;
      break;
    }
  }
  return { response, index };
};

const createObjectWithArray = (array, identifier) => {
  let iterator,
    responseObject = new Object();
  for (let i = 0; i < array.length; i++) {
    iterator = array[i];
    responseObject[iterator[identifier]] = iterator;
  }
  return responseObject;
};

export { updateDataWithId, findWithId, createObjectWithArray };
